const tab_sections = {
    overview: 'Overview',
    resource_management: 'Resource Management',
    user_management: 'User Management',
    help_and_support: 'Help and Support',
};
export default tab_sections;
